import "core-js/modules/es.object.define-property";

var _dataTypes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description:
 */
export var ALL = 'ALL';
export var ALPHA = 'ALPHA'; // abcd

export var ALPHA_NUMERIC = 'ALPHA_NUMERIC'; // a1b2

export var ALPHA_NUMERIC_SPACE = 'ALPHA_NUMERIC_SPACE'; // a 1 b 2

export var ALPHA_NUMERIC_SPECIAL = 'ALPHA_NUMERIC_SPECIAL'; // a1*b2@

export var ALPHA_SPACE = 'ALPHA_SPACE'; // a b c d

export var ALPHA_SPECIAL = 'ALPHA_SPECIAL'; // a*b@

export var BOOLEAN = 'BOOLEAN'; // true/false

export var DATE = 'DATE'; // 01-01-2017

export var EMAIL = 'EMAIL'; // abcd@abcd.com

export var MONTH_2_DIGIT_YEAR = 'MONTH_2_DIGIT_YEAR'; // 01-17

export var MONTH_4_DIGIT_YEAR = 'MONTH_4_DIGIT_YEAR'; // 01-2017

export var NUMERIC = 'NUMERIC'; // 1234

export var NUMERIC_DECIMAL = 'NUMERIC_DECIMAL'; // 1234.12

export var NUMERIC_SPECIAL = 'NUMERIC_SPECIAL'; // 1*2+3@

var dataTypes = (_dataTypes = {}, _defineProperty(_dataTypes, ALPHA, '^[a-zA-Z ]*$'), _defineProperty(_dataTypes, ALPHA_NUMERIC, '^[a-zA-Z0-9 ]*$'), _defineProperty(_dataTypes, ALPHA_NUMERIC_SPACE, '^[a-zA-Z0-9 ]*$'), _defineProperty(_dataTypes, ALPHA_NUMERIC_SPECIAL, '^[a-zA-Z0-9 ~!@#$%^&*()_;=\'"+.-]*$'), _defineProperty(_dataTypes, ALPHA_SPACE, '^[a-zA-Z ]*$'), _defineProperty(_dataTypes, ALPHA_SPECIAL, '^[a-zA-Z ~!@#$%^&*()_;=\'"+-]*$'), _defineProperty(_dataTypes, DATE, '^(((0[13578]|1[02])/?(0[1-9]|[12]\\d|3[01]))|((0[469]|11)/?(0[1-9]|[12]\\d|30))|(02/?(0[1-9]|[12]\\d)))/?\\d{4}$'), _defineProperty(_dataTypes, EMAIL, '^[0-9a-zA-Z_-]+(\\.[0-9a-zA-Z_-]+)*@([0-9a-zA-Z]+[0-9a-zA-Z-]*\\.)+[a-zA-Z]+$'), _defineProperty(_dataTypes, MONTH_2_DIGIT_YEAR, '^(0[1-9]|1[012])/\\d{4}$'), _defineProperty(_dataTypes, MONTH_4_DIGIT_YEAR, '^(0[1-9]|1[012])/20\\d{2}$'), _defineProperty(_dataTypes, NUMERIC, '^[0-9]*$'), _defineProperty(_dataTypes, NUMERIC_DECIMAL, '^[0-9]\\d{0,2}(\\.\\d{1,3})?$'), _defineProperty(_dataTypes, NUMERIC_SPECIAL, '^[0-9 /-]*$'), _dataTypes);
export default dataTypes;